import { useMemo } from 'react';

import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useQueryLojas } from 'pages/cadastro/loja/hooks';
import { Loja } from 'pages/cadastro/loja/types';
import { brlCnpj } from 'util/format';

/**
 * Retorna as linhas do grid
 */
const getRows = (rows: Loja[] = []): GridRowsProp => rows.map((row) => ({ ...row, id: row.idLoja }));

export function LojaGrid() {
    const { hasPermission } = usePermissionsContext();
    const { data, refetch, isFetching } = useQueryLojas();

    const rows = useMemo(() => getRows(data?.data), [data?.data]);

    const columns = useMemo(() => {
        const columns: GridColDef[] = [
            { field: 'cdLoja', headerName: 'Código', minWidth: 80 },
            { field: 'dsRazaoSocial', headerName: 'Razão Social', flex: 1, minWidth: 100 },
            { field: 'dsNomeFantasia', headerName: 'Nome Fantasia', flex: 1, width: 100, minWidth: 110 },
            { field: 'dsCnpj', headerName: 'CNPJ', width: 140, minWidth: 120, valueFormatter: (value) => (value ? brlCnpj(value) : '') },
            { field: 'dsGrupoEconomico', headerName: 'Grupo Econômico', width: 130, minWidth: 120 },
            { field: 'sgEstado', headerName: 'Estado', minWidth: 60 },
            { field: 'dsCidade', headerName: 'Cidade', width: 130, minWidth: 80 },
            { field: 'dsTipoLoja', headerName: 'Tipo de Loja', width: 100, minWidth: 90 },
            { field: 'dsLojaPerfil', headerName: 'Perfil da Loja', width: 100, minWidth: 90 },
            { field: 'fgAtivo', headerName: 'Status', width: 80, minWidth: 60, type: 'boolean' },
        ];

        if (hasPermission(['LOJA_ALTERAR'])) {
            columns.push({
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                width: 80,
                minWidth: 60,
                renderCell: (params) => (
                    <EditRemoveBtn id={params.row.idLoja} sx={{ ml: 'auto', p: 1.5 }} showEditBtn={hasPermission(['LOJA_ALTERAR'])} />
                ),
            });
        }

        return columns;
    }, []);

    return (
        <Block>
            <PanelGrid rows={rows} rowsCount={data?.total ?? 0} reload={refetch} loading={isFetching} columns={columns} visibleRows={10} />
        </Block>
    );
}
